import { ZxcvbnResult } from "@zxcvbn-ts/core";

const zxcvbnPkg = async () => {
  const { zxcvbn, zxcvbnOptions } = await import("@zxcvbn-ts/core");
  const { dictionary, adjacencyGraphs } = await import(
    "@zxcvbn-ts/language-common"
  );
  const { translations } = await import("@zxcvbn-ts/language-en");
  zxcvbnOptions.setOptions({
    dictionary: {
      ...dictionary,
    },
    graphs: adjacencyGraphs,
    translations,
  });
  return zxcvbn;
};

export type StrengthResult = ZxcvbnResult;

export async function passwordStrength(
  password: string,
): Promise<StrengthResult> {
  const zxcvbn = await zxcvbnPkg();
  return zxcvbn(password);
}
